import type { Identifier } from "ra-core";

/** A row of gula_quick_replies: team reply (owner_id null) or someone's own. */
export interface QuickReply {
  id: Identifier;
  owner_id?: Identifier | null;
  label: string;
  body: string;
  sort: number;
  created_at: string;
}

export const PLACEHOLDERS =
  "{nombre} = nombre del cliente · {agente} = tu nombre";

/**
 * The text to send: {nombre} becomes the client's first name and {agente} the
 * agent's. Without a name, "Hola {nombre}," reads "Hola," instead of "Hola ,".
 */
export const fillReply = (
  body: string,
  clientName?: string | null,
  agentName?: string | null,
) => {
  const name = (clientName ?? "").trim();
  const withName = name
    ? body.replaceAll("{nombre}", name)
    : body.replace(/[ ,]*\{nombre\}/g, "");
  return withName.replaceAll(
    "{agente}",
    (agentName ?? "").trim() || "el equipo",
  );
};

/** Team replies first, then the agent's own; each group in its order. */
export const sortReplies = (replies: QuickReply[]) =>
  [...replies].sort(
    (a, b) =>
      Number(a.owner_id != null) - Number(b.owner_id != null) ||
      a.sort - b.sort ||
      a.label.localeCompare(b.label),
  );
